var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoryImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 5.6001H14.4V7.0001H25.6V5.6001Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 7H14.4V9.8H25.6V7Z",
    fill: "#6A6A6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7H16V9.8H24V7Z",
    fill: "#8A8A8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9.7998H8V11.1998H32V9.7998Z",
    fill: "#2A2A2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 11.1997H6.40002V12.5997H33.6V11.1997Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 12.6001H4.80005V23.8001H35.2V12.6001Z",
    fill: "#5A5A5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 12.6001H4.80005V15.4001H12.8V12.6001Z",
    fill: "#7A7A7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60005 15.3999H4.80005V18.1999H9.60005V15.3999Z",
    fill: "#6A6A6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2001 12.6001H27.2001V23.8001H35.2001V12.6001Z",
    fill: "#3A3A3A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 19.6001H24V23.8001H35.2V19.6001Z",
    fill: "#2A2A2A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1999 14H12.7999V15.4H27.1999V14Z",
    fill: "#2A2A2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 15.3999H11.2V16.7999H28.8V15.3999Z",
    fill: "#2A2A2A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 16.7998H9.59998V20.9998H30.4V16.7998Z",
    fill: "#3A3A3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 21H11.2V22.4H28.8V21Z",
    fill: "#2A2A2A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1999 22.3999H12.7999V23.7999H27.1999V22.3999Z",
    fill: "#2A2A2A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1999 15.3999H12.7999V16.7999H27.1999V15.3999Z",
    fill: "#4A4A4A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 16.7998H11.2V20.9998H28.8V16.7998Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1999 21H12.7999V22.4H27.1999V21Z",
    fill: "#4A4A4A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 16.7998H14.4V18.1998H25.6V16.7998Z",
    fill: "#2E5F8F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 18.1997H12.8V19.5997H27.2V18.1997Z",
    fill: "#3A7FB8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 19.5996H12.8V20.9996H27.2V19.5996Z",
    fill: "#4A9FD8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 18.1997H14.4V19.5997H17.6V18.1997Z",
    fill: "#6BC9FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 19.5996H16V20.9996H17.6V19.5996Z",
    fill: "#8FD9FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14H27.2V16.8H32V14Z",
    fill: "#FFD700"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 14H27.2V15.4H28.8V14Z",
    fill: "#FFF68F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 15.3999H30.3999V16.7999H31.9999V15.3999Z",
    fill: "#CCAA00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 11.2002H8V12.6002H11.2V11.2002Z",
    fill: "#C0392B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 11.2002H8V12.6002H9.6V11.2002Z",
    fill: "#E74C3C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 23.7998H6.40002V25.1998H33.6V23.7998Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryImg);
export default __webpack_public_path__ + "static/media/MemoryImg.30e25166193206136c8ca7751af418b8.svg";
export { ForwardRef as ReactComponent };